var _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C27.9411 0 36 8.05888 36 18C36 19.708 35.7621 21.3604 35.3177 22.9259C33.1753 30.4724 26.2332 36 18 36C8.05888 36 0 27.9411 0 18C0 8.05888 8.05888 0 18 0Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8.00159,
    width: 6.7053,
    height: 6.70156,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 21.3004,
    width: 6.69367,
    height: 6.68993,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2947,
    y: 8.00146,
    width: 6.7053,
    height: 6.70156,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6937,
    y: 14.7031,
    width: 6.60103,
    height: 6.59735,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2947,
    y: 21.3004,
    width: 6.7053,
    height: 6.69797,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkex);
export default __webpack_public_path__ + "static/media/okex.4ab5c75b2d82e6a0368ff2aff3d38ee7.svg";
export { ForwardRef as ReactComponent };